import { useQuery } from "@tanstack/react-query";
import { API_BASE } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetBaseInfo = <T>() => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_BASE_INFO],
        queryFn: () => API_BASE.getBaseInfo<T>(),
    });

    return { data, isLoading };
};
